import { render, staticRenderFns } from "./invoice_details_dialog.vue?vue&type=template&id=1a47e153"
import script from "./invoice_details_dialog.vue?vue&type=script&lang=js"
export * from "./invoice_details_dialog.vue?vue&type=script&lang=js"
import style0 from "./invoice_details_dialog.vue?vue&type=style&index=0&id=1a47e153&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports